<div class="header-bottonsheet">
    <img src="/assets/icons/bs-header-background.svg" alt="">
    <h3 class="upper-case">{{ translate.instant('notifications') }}</h3>
    <button mat-button class="close-btn" (click)="_bottomSheetRef.dismiss()">
        <img src="/assets/icons/modal-close.svg" alt="">
    </button>
</div>
<mat-list>
    <ng-container
        *ngIf="notificationService.getNotifications && notificationService.getNotifications.length; else emptyNotification">
        <div *ngFor="let notification of notificationService.getNotifications; let i = index" class="flex-between">
            <!-- Session Extension -->
            <ng-container *ngIf="notification.type == alertType.extendSession">
                <mat-list-item matRipple>
                    <span>{{ notification.extendSession.eventName }} : </span>
                    <span>{{ translate.instant('extra') }}</span>
                    <span>{{
                        helperService.convertMinutesToFriendlyString(notification.extendSession.minutes) }} </span>
                    <span>{{ translate.instant('requested') }}</span>
                </mat-list-item>
                <div class="action-buttons flex-end">
                    <button mat-button (click)="notificationService.onReject(notification.extendSession)">
                        <span>{{ translate.instant('reject') }}</span>
                    </button>
                    <button mat-button (click)="notificationService.onApproved(notification.extendSession)">
                        <span>{{ translate.instant('approve') }}</span>
                    </button>
                </div>
            </ng-container>
            <!-- Assistance -->
            <ng-container *ngIf="notification.type == alertType.assistance">
                <mat-list-item matRipple>
                    <span>{{ notification.alertBody }}</span>
                </mat-list-item>
                <div class="flex-end">
                    <button mat-button (click)="notificationService.dismissAssistance(notification.assistance)">
                        <span>{{ translate.instant('dismiss') }}</span>
                    </button>
                </div>
            </ng-container>
            <!-- Refresh application -->
            <ng-container *ngIf="notification.type == alertType.refreshApplication">
                <mat-list-item matRipple>
                    <span>{{ translate.instant('needToRefresh') }}</span>
                </mat-list-item>
                <div class="flex-end">
                    <button mat-button (click)="notificationService.refreshApplication()">
                        <span>{{ translate.instant('refresh') }}</span>
                    </button>
                </div>
            </ng-container>
            <mat-divider *ngIf="i < notificationService.getNotifications.length - 1"></mat-divider>
        </div>
    </ng-container>
    <ng-template #emptyNotification>
        <p class="empty-list">{{ translate.instant('none') }}</p>
    </ng-template>
</mat-list>